import React, { useRef, FC, useEffect } from "react";
import { message } from "antd";
import { IYhFormRef, FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { useDiscernModel } from "../../discernModel";
import { discernService, IDistinguishUpdateField } from "../../discernService";
import { RouterParamType } from "@/model/navModel";

export const LabelInfoDrawer: FC<RouterParamType> = ({ id, mode }) => {
	const { LabelInfoDrawer: visible, setLabelInfoDrawer, discernOne, getDiscernOne, setSelectedRowKeys } = useDiscernModel();
	const formRef = useRef<IYhFormRef>();

	const onCancel = () => {
		setLabelInfoDrawer(false);
	}

	useEffect(() => {
		return () => {
			onCancel()
		}
	}, []);

	//表单提交
	const onSubmit = async () => {
		formRef.current?.validateFields().then((val: IDistinguishUpdateField) => {
			discernService.distinguishUpdate({
				...val,
				status: "1",
				id: discernOne?.id
			}).then(res => {
				if (res) {
					message.success("标注成功");
					onCancel();
					getDiscernOne(id)
					// setSelectedRowKeys(origin => origin.filter((item) => item.id !== discernOne?.id))
				}
			})
		}).catch(err => {
			message.warning(getFormValidatorErrText(err));
		})
	}



	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 8 },
		formValues: discernOne,
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "项目名称",
				fieldName: "name",
				span: 12,
				rules: [{ required: true, message: "请输入项目名称" }]
			},
			{
				type: FormItemTypeEnum.Select,
				fieldLabel: "有用等级",
				fieldName: "grade",
				span: 12,
				options: [
					{ label: "一级", value: "一级" },
					{ label: "二级", value: "二级" },
					{ label: "三级", value: "三级" }
				]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "项目编码",
				fieldName: "code",
				span: 12,
				// rules: [{ required: true, message: "请输入分类名称" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "关键词",
				fieldName: "keywords",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "规格简要",
				fieldName: "specificSummary",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "地区",
				fieldName: "region",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "预算金额",
				fieldName: "price",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "发布时间",
				fieldName: "pubTime",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Select,
				fieldLabel: "是否参与",
				fieldName: "isJoin",
				span: 12,
				options: [{ label: "是", value: "1" }, { label: "否", value: "0" }]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "截止时间(投标)",
				fieldName: "bidEndTime",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "售价",
				fieldName: "sellingPrice",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Select,
				fieldLabel: "公告类型",
				fieldName: "noticeType",
				span: 12,
				options: [
					{ label: "公告", value: "公告" },
					{ label: "邀请公告", value: "邀请公告" },
					{ label: "补遗公告", value: "补遗公告" },
					{ label: "中标公告", value: "中标公告" },
				]
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "交货时间",
				fieldName: "deliveryTime",
				span: 12,
				hidden: true
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "交货地点",
				fieldName: "deliveryAddress",
				span: 12,
				hidden: true
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "采购单位",
				fieldName: "purchaser",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "采购单位联系方式",
				fieldName: "purchaserContacts",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "代理机构名称",
				fieldName: "agent",
				span: 12,
				hidden: true
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "代理机构地址",
				fieldName: "agentAddress",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "代理机构联系方式",
				fieldName: "agentContacts",
				span: 12,
				hidden: true
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "链接",
				fieldName: "detailLink",
				span: 12,
			},
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "备注",
				fieldName: "note",
				span: 12,
			},

		]
	};
	return (
		<YHDrawer
			{...{
				title: `信息标注`,
				visible,
				onCancel,
				width: 750,
				okText: "保存",
				onOk: onSubmit,
				maskClosable: false,
				drawerWidth: 780
			}}
		>
			<YhForm {...formConfig} />
		</YHDrawer>
	)
}
